module.exports = __webpack_public_path__ + "static/media/Cybercellar.f556704d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mockAPI/images/Cybercellar.jpg
// module id = 263
// module chunks = 0